// bg-card/border-border em vez de bg-white/border-gray-100: o shim legado de
// dark mode em src/index.css mira `bg-white` diretamente (fora de @layer,
// depois de @tailwind utilities) e vence qualquer `dark:bg-X` no empate de
// especificidade — as classes semanticas do shadcn escapam disso e viram
// dark automaticamente pelas CSS vars. Ver marketing.design.js.
export const GENERIC_TABLE_DESIGN = {
    container: "bg-card rounded-xl border border-border shadow-sm overflow-hidden",
    wrapper: "overflow-x-auto",
    innerWrapper: "min-w-full inline-block align-middle",
    header: {
        container: "border-b border-border bg-muted/50 px-6 py-3 flex items-center text-xs font-semibold text-muted-foreground uppercase tracking-wider",
    },
    row: {
        container: "group px-6 py-4 flex items-center border-b last:border-b-0 border-border/60 hover:bg-accent/50 transition-colors",
    },
    // Helper classes for common elements within the table
    common: {
        iconBox: "w-10 h-10 rounded-lg bg-brand-600/10 flex items-center justify-center text-brand-600 dark:text-violet-400",
        badge: {
            container: "flex items-center gap-2 bg-muted border border-border rounded-lg py-1.5 px-3 max-w-full",
            text: "text-xs text-muted-foreground truncate flex-1 font-mono",
            button: "text-muted-foreground hover:text-violet-600 dark:hover:text-violet-400 transition-colors"
        },
        deleteButton: "p-2 rounded-lg text-muted-foreground hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 transition-all",
        // Common column styles
        colMain: "flex-1 min-w-[200px] pr-4",
    }
};
